import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormFeedback,
  Spinner,
} from "reactstrap"
import classnames from "classnames"
import { Link, useParams } from "react-router-dom"
import LoadingButton from "../../../components/Common/LoadingButton"
import { UFDate, UFInput } from "../../../components/Common/Fields/Input"
import { useForm, FormProvider } from "react-hook-form"
import { Form, FormGroup, Label } from "reactstrap"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import closeIcon from "../../../assets/icons/close.svg"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"

import SingleFileInput from "../../../components/Common/Fields/singleFileInput"
import {
  fetchEmployeeDocumentEdit,
  postHrmsEmployeeDocument,
} from "../../../services/Hrms/hrms"
import moment from "moment"
import Document from "../../../components/Common/chooseFields/document"

const schema = yup.object().shape({
  document_title: yup.mixed().required("Document Title is Required"),
  document_no: yup.string().required("Document Number is required"),
  // expiry_date: yup.string().required("Expiry Date is required"),
})
const Edit = ({ loading, onUpdate, close, getEditValue }) => {
  const { id } = useParams()

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      document_title: null,
      document_no: "",
      expiry_date: null,
      certificates: "",
    },
  })
  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
  })
  const [isLoading, setIsLoading] = useState(false)
  const [certificateSts, setCertificateSts] = useState()
  useEffect(() => {
    setCertificateSts(getEditValue?.data?.filepath)
    reset({
      ...getEditValue?.data,
      document_title: {
        label: getEditValue?.data?.document_title?.name,
        value: getEditValue?.data?.document_title?.id,
      },
    })
  }, [getEditValue])

  const handleRegistration = async data => {
    try {
      setIsLoading(true)
      const updateDepartment = await postHrmsEmployeeDocument({
        ...data,
        basicdetails_id: id,
        document_title: data?.document_title?.value,
        document_no: data?.document_no,
        expiry_date: data?.expiry_date ? moment(data?.expiry_date).format("YYYY-MM-DD") : null,
        ...(data?.certificates?.[0] instanceof File
          ? {
              certificates: data?.certificates?.[0],
            }
          : {
              certificates: "",
            }),
      })
      toastSuccess(updateDepartment?.message)
      onUpdate()
      close()
    } catch (err) {
      toastError(err?.message)
    } finally {
      setIsLoading(false)
    }
  }

  const handleChange = (name, file) => {
    setValue(name, file)
    setCertificateSts("")
  }
  return (
    <>
      <ModalHeader className="custom-modal-header">
        <div className="d-flex justify-content-between">
          <h5>{getEditValue?.data?.id ? "Edit Document" : "Add Document"}</h5>
          <img
            src={closeIcon}
            alt=""
            onClick={close}
            width="10"
            role="button"
          />
        </div>
      </ModalHeader>
      {loading ? (
        <div
          className="px-8"
          style={{
            width: "100%",
            textAlign: "center",
            minHeight: "200px",
            paddingTop: "90px",
          }}
        >
          <Spinner
            className={classnames({
              "mx-2": true,
              "position-relative": true,
              visible: true,
            })}
            size="md"
          />
        </div>
      ) : (
        <>
          <ModalBody>
            <FormProvider {...methods}>
              <Form id={`ev-form`} onSubmit={handleSubmit(handleRegistration)}>
                <Row>
                  <Col sm={12}>
                    <FormGroup className="mb-4">
                      <Label>
                        Document Title<span className="mandatory">*</span>
                      </Label>
                      <Document
                        control={control}
                        placeholder="Select the Document Title"
                        name={`document_title`}
                        invalid={!!errors?.document_title}
                      />
                      <FormFeedback invalid>
                        {errors.document_title?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <FormGroup className="mb-4">
                      <Label>
                        Document Number<span className="mandatory">*</span>
                      </Label>
                      <UFInput
                        control={control}
                        placeholder="Enter the Document Number"
                        name={`document_no`}
                        invalid={!!errors?.document_no}
                      />
                      <FormFeedback invalid>
                        {errors.document_no?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <FormGroup className="mb-4">
                      <Label>
                        Expire Date
                      </Label>
                      <UFDate
                        control={control}
                        name={`expiry_date`}
                        invalid={!!errors?.expiry_date}
                      />
                      <FormFeedback invalid>
                        {errors.expiry_date?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <FormGroup className="mb-4">
                      <Label>
                        upload<span className="mandatory">*</span>
                      </Label>
                      <SingleFileInput
                        accept=".png,.jpg,.jpeg,.svg,.pdf"
                        name={`certificates`}
                        label="Upload File"
                        onlyIcon={true}
                        tooltip="Document Upload"
                        handleChange={handleChange}
                        downloadPath={certificateSts}
                      />
                      <FormFeedback invalid>
                        {errors.certificates?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            </FormProvider>
          </ModalBody>
          <ModalFooter>
            <LoadingButton
              form={`ev-form`}
              color={"primary"}
              loading={isLoading}
              disabled={isLoading}
              type="submit"
            >
              {getEditValue?.data?.id ? "Update" : "Save"}
            </LoadingButton>
          </ModalFooter>
        </>
      )}
    </>
  )
}

const EditDocument = ({
  buttonLabel,
  className,
  editValue,
  modelOpen,
  ...props
}) => {
  const [modal, setModal] = useState(false)
  const [getEditValue, setGetEditValue] = useState("")

  const toggle = () => setModal(!modal)
  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchEmployeeDocumentEdit(editValue?.id)
      if (response?.status) {
        setGetEditValue(response)
      }
    }
    if (editValue?.id) {
      fetchData()
    }
  }, [editValue?.id])
  useEffect(() => {
    if (modelOpen) {
      setModal(true)
    }
  }, [modelOpen])

  return (
    <>
      <Link to="#" className={className} onClick={toggle}>
        {buttonLabel}
      </Link>
      <Modal isOpen={modal} toggle={toggle} size="md" backdrop={"static"}>
        <Edit
          close={() => {
            setModal(false)
            setGetEditValue("")
            props?.onReset()
          }}
          getEditValue={getEditValue}
          {...props}
        />
      </Modal>
    </>
  )
}

export default EditDocument
